// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VisuallyHidden_wrapper__rfGWb","pulse":"VisuallyHidden_pulse__bP77r"};